// extracted by mini-css-extract-plugin
export var bgImg = "bottomCta-module--bgImg--c8G+Z";
export var btn = "bottomCta-module--btn--0wSo9";
export var christmasTreeImg = "bottomCta-module--christmasTreeImg--TJ06F";
export var creditCard180Dnej = "bottomCta-module--creditCard180Dnej--H1hHs";
export var creditCardImg = "bottomCta-module--creditCardImg--pyDsn";
export var creditCardMedia = "bottomCta-module--creditCardMedia--y3Zfr";
export var dnejImg = "bottomCta-module--dnejImg--a0-yY";
export var halvaImg = "bottomCta-module--halvaImg--BThYb";
export var ivanCardImg = "bottomCta-module--ivanCardImg--OS3vM";
export var newYearMedia = "bottomCta-module--newYearMedia--0xY6G";
export var percentLeftImg = "bottomCta-module--percentLeftImg--1vSjS";
export var percentRightImg = "bottomCta-module--percentRightImg--sFXwk";
export var pkwCardImg = "bottomCta-module--pkwCardImg--0HGGP";
export var pkwCreditCards = "bottomCta-module--pkwCreditCards--8cuUP";
export var pkwRubImg = "bottomCta-module--pkwRubImg--FGCvK";
export var section = "bottomCta-module--section--kvl1+";
export var tenMonthsImg = "bottomCta-module--tenMonthsImg--ReMT3";
export var text = "bottomCta-module--text--qUTWk";
export var wrap = "bottomCta-module--wrap--UtHpD";
export var wrapper = "bottomCta-module--wrapper--ak+ge";